(function($, root) {

  $('html').on('click touchstart', '.show-modal header .menu-icon', function() {
    if (window.rdo.modal.shown) {
      $.showTimelinePlayerModal(function() {
        console.log('SHOWING TIMELINE PLAYER 4');
        window.rdo.preloading = 'this';
        if (window.rdo.data.selected.content.subject) {
          $.selectSubject(window.rdo.data.selected.subject.index);
        } else {
          $.selectContent(window.rdo.data.selected.content.index);
        }
      });
    }
  });

  $('html').on('click touchstart', 'footer .open-modal', function() {
    let modalname = $(this).attr('data-href');
    if (!window.rdo.modal.shown && window.rdo.data.page[modalname]) {
      console.log('load modal' + $(this).attr('data-href'));
      $.showModal(modalname);
    }
  });

  $.showTimelinePlayerModal = function(callbacks) {
    console.log('SHOWING TIMELINE PLAYER 1');
    // $.renderTimelinePlayer();

    $('main .main').removeClass('fadeOut').addClass('fadeIn');

    $('modal .modalholder').removeClass('fadeIn').animateCss('fadeOut', function() {
      window.rdo.header.shown = false;

      console.log('SHOWING TIMELINE PLAYER 2');

      $('body').removeClass('show-modal').addClass('show-content');
      $('modal').html('');
      $('modal').removeClass('active');

      setTimeout(function() {
        console.log('SHOWING TIMELINE PLAYER 3');
        // console.log('CLOSE INDEX + TIMEOUT 500 DONE');
        $('main').fadeIn();
        $('modal').fadeOut();
        $('#vertical-timeline').getInitialScrollPositions('.sitem', '#vertical-timeline .wrapper');
        callbacks();
      }, 500);

      setTimeout(function() {
        // console.log('CLOSE INDEX + TIMEOUT 1500 DONE');
        window.rdo.modal.shown = false;
      }, 1500);

      // setTimeout(function() {
      //   $('body').removeClass('dark-bg');
      // }, 2000);

    });

  };

  $.showModal = function(modal) {
    $.pauseTimer(true);
    $.renderModal(modal);
    // $.hideSpinner();
    $('body').addClass('dark-bg');
    $('modal .modalholder').removeClass('fadeOut')
      // .addClass('fadeIn');

      .animateCss('fadeIn', function() {
        console.log('modal fadein ended');
        // $('body').addClass('dark-bg');
        // $('main').fadeOut();
        $('main').html('');

      });

    // .addClass('fadeIn');

    $.hideMain("modal");

  };

})(jQuery, this);
